<div *ngIf='{desktop: (deviceS.isDesktop$|async),
             mobile: (deviceS.isMobile$|async)
            } as obj' class='wrapperTableEmpty'>
  <div *ngIf='tableEmpty.title' class='wrapperTableEmpty__title'>{{ tableEmpty.title }}</div>
  <div *ngIf='tableEmpty.subTitle' class='wrapperTableEmpty__subTitle'>{{ tableEmpty.subTitle }}</div>
  <ng-container *ngIf='tableEmpty.showBtn'>
    <ng-content select='.class_ngContent_btn_for_nothingList'></ng-content>
  </ng-container>
</div>